import axios from '../../request/http';

const buildListParams = (params = {}) => {
  const pageNum = Number(params.pageNum) || 1;
  const pageSize = Number(params.pageSize) || 10;
  const query = {
    pageNum: pageNum < 1 ? 1 : pageNum,
    pageSize: pageSize
  };
  if (params.style) {
    query.style = params.style;
  }
  return query;
};

const commentApi = {
  getRobotCommentList(params) {
    return axios.get('/hemei-admin/robot/getRobotCommentList', { params: buildListParams(params) });
  },
  addRobotComment(data) {
    return axios.post('/hemei-admin/robot/addRobotComment', data);
  },
  updateRobotComment(data) {
    return axios.post('/hemei-admin/robot/updateRobotComment', data);
  },
  delRobotComment(params) {
    return axios.get('/hemei-admin/robot/delRobotComment', { params });
  }
};

export default commentApi;



// WEBPACK FOOTER //
// ./src/api/robot/comment.js